/* tslint:disable */
/* eslint-disable */

/**
 * MessagingTemplate Variables Enum for Messaging (manually registered in swagger)
 */
export enum WorkMessagingTemplateVariablesEnum {
  FirstName = 'firstName',
  LastName = 'lastName',
  TitleName = 'titleName',
  InvoiceReminderLevel = 'invoiceReminderLevel',
  InvoiceNumber = 'invoiceNumber',
  InvoiceDate = 'invoiceDate',
  AppointmentLocation = 'appointmentLocation',
  ReservationTypeDescription = 'reservationTypeDescription',
  AppointmentStartDate = 'appointmentStartDate',
  AppointmentTypeName = 'appointmentTypeName',
  AppointmentDurationWithUnit = 'appointmentDurationWithUnit',
  ResponsiblePersonFullName = 'responsiblePersonFullName',
  ResponsiblePersonRole = 'responsiblePersonRole',
  ArticleName = 'articleName',
  CancelledAppointmentsList = 'cancelledAppointmentsList',
  CancelledProjectsList = 'cancelledProjectsList',
  ProjectNumberQualified = 'projectNumberQualified',
  ProjectObjectAddress = 'projectObjectAddress',
  StornoReason = 'stornoReason',
  StornoNotes = 'stornoNotes',
  StornoExecutedBy = 'stornoExecutedBy',
  StornoActionsList = 'stornoActionsList',
  StornoTodoList = 'stornoTodoList',
  ProjectLink = 'projectLink',
  ProjectShareLink = 'projectShareLink',
  ProjectSharePin = 'projectSharePin',
  ProjectShareValidUntil = 'projectShareValidUntil',
  Signature = 'signature',
  EmployeeFullName = 'employeeFullName',
  TrialPeriodTo = 'trialPeriodTo'
}
